<breadcrumbs
  [breadcrumbs]="[{ label: 'ADMIN', url: '/admin' }, { label: 'DATA_CYCLES' }]"
></breadcrumbs>

<page-header title="DATA_CYCLES"></page-header>

<app-table
  [isLoading]="isLoading"
  [totalItems]="state.get('total')"
  [totalResults]="state.get('results')"
  [itemsPerPage]="getQueryParam('page_size')"
  [rows]="state.get('data')"
  [currentPage]="getQueryParam('page')"
  (onPageChange)="handlePageChange($event)"
  (onSort)="handleSort($event)"
  [sort]="getQueryParam('sort')"
  [orderBy]="getQueryParam('order_by')"
  [columns]="columns"
  (onPageSizeChange)="handlePageSizeChange($event)"
>
  <ng-template #addonLeft>
    <div class="buttons m-0">
      <a
        *ngxPermissionsOnly="['CREATE_DATA_CYCLE']"
        [routerLink]="['create']"
        class="button is-small is-info"
        translationEditableDirective="CREATE_DATA_CYCLE"
        >{{ 'CREATE_DATA_CYCLE' | translate }}</a
      >
      <a
        *ngxPermissionsOnly="['SWITCH_DATA_CYCLE']"
        [routerLink]="['switch']"
        class="button is-small is-info"
        translationEditableDirective="SWITCH_DATA_CYCLE"
        >{{ 'SWITCH_DATA_CYCLE' | translate }}</a
      >
    </div>
  </ng-template>

  <ng-template #addonRight>
    <form>
      <input
        class="input is-small"
        type="text"
        (input)="handleFilterChange($event)"
        [value]="getQueryParam('keyword')"
        name="keyword"
        [placeholder]="'SEARCH' | translate"
        [translationEditableModalDirective]="['SEARCH']"
      />
    </form>
  </ng-template>

  <ng-template let-row="row" #actionsColumn>
    <div class="buttons m-0">
      <a
        *ngxPermissionsOnly="['UPDATE_DATA_CYCLE']"
        [routerLink]="[row.get('id'), 'update']"
        class="button is-small"
        translationEditableDirective="UPDATE"
        >{{ 'UPDATE' | translate }}</a
      >
      <alert
        #deleteAlert
        (confirm)="deleteDataCycle(row.get('id'))"
        titleTrnKey="ARE_YOU_SURE"
        textTrnKey="YOU_WONT_BE_ABLE_TO_REVERT_THIS"
      />
      <button
        class="button is-danger is-small"
        (click)="deleteAlert.fire()"
        translationEditableDirective="DELETE"
        *ngxPermissionsOnly="['DELETE_DATA_CYCLE']"
      >
        {{ 'DELETE' | translate }}
      </button>
    </div>
  </ng-template>
</app-table>
